"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const utils_1 = require("../../lib/utils");
const style_1 = require("./style");
const ProviderInfo = ({ provider }) => {
    const providerName = (0, utils_1.formatProviderName)({
        name: provider.name,
        degrees: provider.degrees
    });
    const providerSpecialties = (0, utils_1.formatProviderSpecialties)(provider === null || provider === void 0 ? void 0 : provider.specialties);
    return (react_1.default.createElement(style_1.Row, { id: "provider-info" },
        react_1.default.createElement(style_1.ProviderImg, { "data-testid": "provider-image", width: 40, height: 40, src: (0, utils_1.getProviderImageUrl)(provider), alt: '' }),
        react_1.default.createElement(style_1.ProviderTitleSpecialtiesContainer, null,
            react_1.default.createElement(style_1.ProviderTitle, { id: "provider-name", "data-testid": "provider-title" }, providerName),
            react_1.default.createElement(style_1.ProviderSpecialities, { id: "provider-specialities", "data-testid": "provider-specialties" }, providerSpecialties))));
};
exports.default = ProviderInfo;
//# sourceMappingURL=ProviderInfo.js.map